(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('CompanyBatchUpdateFranchiserController', CompanyBatchUpdateFranchiserController)

    /** @ngInject */
    function CompanyBatchUpdateFranchiserController(sweetAlert, $q, CompanyService, RegionalService, CategoryService, ClusterService,
        LoadingHelper, UtilHelper, CompanyStatusService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let hasModifiedSearchStatus = false;
        let isFirstCall = true;

        // First Step
        vm.isSearchDisabled = () => {
            if (vm.searchSelectedCluster || vm.searchSelectedRegional || vm.searchSelectedStatus || hasModifiedSearchStatus || (vm.searchSelectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.searchSelectedCluster || vm.searchSelectedRegional || vm.searchSelectedStatus || hasModifiedSearchStatus || vm.searchSelectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.changeCompanyStatus = status => {
            if (vm.searchSelectedStatus && vm.searchSelectedStatus.Id == 6) return;

            vm.searchStatus = status;
            hasModifiedSearchStatus = true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                isFirstCall = false;
                vm.isFirstCall = false;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.searchSelectedCluster = null;
            vm.searchSelectedRegional = null;
            vm.searchSelectedStatus;
            vm.searchSelectedSearchField = null;
            vm.searchText = null;
            vm.searchStatus = null;
            hasModifiedSearchStatus = false;
            isTableSearch = false;
            vm.companies = [];
            vm.isFirstCall = true;
            isFirstCall = true;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (isFirstCall)
                return;

            vm.isLoading = true;
            isFirstCall = false;
            vm.isFirstCall = false;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getCompanies(start, number, tableState);
        }

        vm.toggleSelectedCompany = company => {
            if (vm.selectedCompanies.find(x => x.Id == company.Id)) {
                vm.selectedCompanies = vm.selectedCompanies.filter(x => x.Id != company.Id);
            } else {
                vm.selectedCompanies.push(company);
                vm.companies = vm.companies.filter(x => x.Id != company.Id);
            }
        }

        vm.goToEditionStep = () => {
            vm.currentStep = 2;
        }

        vm.goToSelectionStep = () => {
            vm.currentStep = 1;
        }

        // Second step
        vm.saveCompanyData = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    let updateData = {
                        CompanyIds: vm.selectedCompanies.reduce((acc, cur) => {
                            if (!acc.find(x => x == x.Id))
                                acc.push(cur.Id);

                            return acc;
                        }, [])
                    };

                    if (vm.selectedStatus)
                        updateData.StatusId = vm.selectedStatus.Id;

                    if (vm.selectedCluster)
                        updateData.ClusterId = vm.selectedCluster.Id;

                    if (vm.selectedRegional)
                        updateData.RegionalId = vm.selectedRegional.Id;

                    if (vm.selectedCategory)
                        updateData.CategoryId = vm.selectedCategory.Id;

                    CompanyService
                        .batchUpdate(updateData)
                        .then(() => {
                            initVars();
                            LoadingHelper.stopLoading('.loading-holder');
                            UtilHelper.successCallback('update');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.loading-holder');
                        })
                }
            })
        }

        init();

        function getCompanies(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            CompanyService
                .getByParameters(parameters)
                .then(success => {
                    let companies = success.Registers;
                    vm.companies = companies.filter(x => !vm.selectedCompanies.find(y => y.Id == x.Id) && x.CompanyIdParent);

                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.companies = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function getCategories() {
            CategoryService
                .getAll()
                .then(success => {
                    vm.categories = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function getRegionals() {
            RegionalService
                .getAll()
                .then(success => {
                    vm.regionals = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function getClusters() {
            return ClusterService
                .getAll()
                .then(success => {
                    vm.clusters = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function getStatus() {
            return CompanyStatusService
                .getAll()
                .then(success => {
                    vm.status = success.Registers;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'FantasyName',
                OrderDescending: false
            }

            if (vm.searchSelectedCluster || vm.searchSelectedRegional || vm.searchSelectedStatus || vm.searchStatus > 0 || (vm.searchSelectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.searchStatus > 0)
                params.Active = vm.searchStatus == 1;

            if (vm.searchSelectedCluster)
                params.ClusterId = vm.searchSelectedCluster.Id;

            if (vm.searchSelectedRegional)
                params.RegionalId = vm.searchSelectedRegional.Id;

            if (vm.searchSelectedStatus)
                params.StatusId = vm.searchSelectedStatus.Id;

            if (vm.searchSelectedStatus && vm.searchSelectedStatus.Id == 6) {
                vm.searchStatus = null;
                params.Closed = true;
                params.Active = false;
            }

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.searchSelectedSearchField && vm.searchText) {
                params.SearchField = vm.searchSelectedSearchField.Value;
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function initVars() {
            vm.searchSelectedRegional;
            vm.searchSelectedStatus;
            vm.searchSelectedCluster;
            vm.searchSelectedSearchField;
            vm.searchText;
            vm.searchStatus = null;
            vm.isLoading = false;
            vm.isFirstCall = true;
            vm.selectedCompanies = [];
            vm.currentStep = 1;

            vm.selectedCategory;
            vm.selectedRegional;
            vm.selectedStatus;
            vm.selectedCluster;

            vm.searchFields = [{
                Value: 'Id',
                Description: 'Id'
            }, {
                Value: 'Document',
                Description: 'CNPJ'
            }, {
                Value: 'CorporateName',
                Description: 'Razão Social'
            }, {
                Value: 'FantasyName',
                Description: 'Nome Fantasia'
            }, {
                Value: 'ExternalCode',
                Description: 'Código Empresa'
            }, {
                Value: 'UniqueCode',
                Description: 'Código Único'
            }];
        }

        function init() {
            LoadingHelper.startLoading('.custom-filters');

            initVars();

            $q.all([getCategories(), getRegionals(), getClusters(), getStatus()])
                .then(() => {
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }
    }
}());